var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.569 47.569",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#de4394;}.cls-2{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Product_Name_Generator",
    "data-name": "Product Name Generator"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23.784,
    cy: 23.784,
    r: 23.784
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.784,13.478a4.767,4.767,0,0,0-4.752,4.677c0,.027,0,.053,0,.08v.792H16.649a.794.794,0,0,0-.793.793v6.343a21.953,21.953,0,0,0,.107,2.957,3.167,3.167,0,0,0,3.282,3.28,10.85,10.85,0,0,0,2.161.105h4.757a10.66,10.66,0,0,0,2.164-.107,3.164,3.164,0,0,0,3.28-3.281,21.744,21.744,0,0,0,.105-2.954V19.82a.793.793,0,0,0-.792-.793H28.541v-.792c0-.03,0-.06,0-.09A4.768,4.768,0,0,0,23.784,13.478Zm0,1.585a3.163,3.163,0,0,1,3.172,3.172v.792H20.613v-.792a3.163,3.163,0,0,1,3.171-3.172Zm-6.342,5.55h1.585V22.2a.793.793,0,0,0,1.586.022V20.613h6.343V22.2a.793.793,0,1,0,1.585.022V20.613h1.586v5.55a21.077,21.077,0,0,1-.1,2.775,1.666,1.666,0,0,1-1.881,1.883,9.438,9.438,0,0,1-1.987.1H21.406a9.525,9.525,0,0,1-1.982-.1,1.666,1.666,0,0,1-1.883-1.882,20.8,20.8,0,0,1-.1-2.779Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.178d5f3f3e13a09f8ecffcb8ae764bd3.svg";
export { ForwardRef as ReactComponent };